import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    FETCH_PRODUCT_LIST_FAILURE,
    FETCH_PRODUCT_LIST_SUCCESS,
} from '../../redux/modules/addBulkItemsInPurchaseOrder/addBulkItemsInPurchaseOrder-actions';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import messages from '../../constants/messages';
import { generateAddBulkItemsSearchConstruct } from '../../containers/StockManagementContainer/AddBulkItemsUtil';

function* fetchProductsForPurchaseOrderWorker(action) {
    try {
        const config = {
            headers: { 'Content-Type': 'application/json' },
        };
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const {
            api, page, size, filters, warehouseId,
        } = action;
        const searchConstruct = generateAddBulkItemsSearchConstruct(filters);
        const apiWithParams = `${api}?page=${page}&size=${size}&warehouseUuid=${encodeURIComponent(warehouseId)}`;
        const response = yield call(retriable().post, apiWithParams, searchConstruct, config);
        yield put({
            type: FETCH_PRODUCT_LIST_SUCCESS,
            data: response.data,
            filters: action.filters,
            warehouseId,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.BATCHES.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: FETCH_PRODUCT_LIST_FAILURE });
    } finally {
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchProductsForPurchaseOrderWorker;
